/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {PeriodTypeInfoChartComponent} from './period-type-info-chart.component';
import {CommonModule} from '@angular/common';
import {TooltipModule} from '../../../../shared/tooltip/tooltip.module';

@NgModule({
    declarations: [PeriodTypeInfoChartComponent],
    imports: [CommonModule, TooltipModule],
    exports: [PeriodTypeInfoChartComponent]
})
export class PeriodTypeInfoChartModule {
}
